import authApi from '@/apis/auth-api';

const auth = {
  state: {
    token: null,
    user: ''
  },
  getters: {
    get_userName(state) { return state.user.name; },
    get_token(state) { return state.token; }
  },
  mutations: {
    set_user(state, user) {
      state.user = user;
    },
    set_token(state, token) {
      state.token = token;
    }
  },
  actions: {
    login({ commit }, payload) {
      const credentials = payload;
      return authApi.login(credentials).then((response) => {
        commit('set_token', response.token);
        commit('set_user', response.user);
        return response;
      });
    },
    refresh({ commit }) {
      return authApi.refresh().then((response) => {
        commit('set_token', response.token);
        commit('set_user', response.user);
        return response;
      });
    }
  }
};

export default auth;



// WEBPACK FOOTER //
// ./src/store/auth/index.js